import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import { DOC2API_URL } from 'src/pages/APIs';
import { cleanUpImagePath } from 'src/utils/viewImages';

export const useDocTableSelectionStore = defineStore('table_selection', {
  state: () => ({
    processing: false,
    page: 1,
    image: '',
    baseUrl: '',
    imageWidth: 0,
    imageHeight: 0,
    imageInfo: {} as any,
    image_container: {} as any,
    image_el: {} as any,
  }),
  getters: {},
  actions: {
    setImage(record: dynamicObj) {
      this.baseUrl = DOC2API_URL;
      this.image = '';
      this.image =
        this.baseUrl +
        '/' +
        cleanUpImagePath(record.images[this.page - 1].path);
    },
  },
});
